import { useCallback, useEffect, useState } from "react";

const defaultProps = { defaultNetworkStatus: null };

export const NetworkStatus = {
  ONLINE: "online",
  OFFLINE: "offline"
};

const useWebNetworkStatus = ({ defaultNetworkStatus } = defaultProps) => {
  const [networkStatus, setNetworkStatus] = useState(defaultNetworkStatus);

  const handleOnline = useCallback(() => {
    setNetworkStatus(NetworkStatus.ONLINE);
  }, []);

  const handleOffline = useCallback(() => {
    setNetworkStatus(NetworkStatus.OFFLINE);
  }, []);

  useEffect(() => {
    if (!navigator.onLine) {
      handleOffline();
    } else if (networkStatus !== NetworkStatus.ONLINE) {
      handleOnline();
    }
  }, []);

  useEffect(() => {
    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, [handleOnline, handleOffline]);

  // Always return online to prevent showing offline status on web
  return { networkStatus: NetworkStatus.ONLINE };
};

export default useWebNetworkStatus;
